import React from 'react';
import styles from './PageNotFound.module.css';

const PageNotFound = () => {
    return (
        <div className={styles.root}>
            <h2 >{'Неверный адрес'}</h2>
            <h1>404</h1>
            <h2 >{'Как вы сюда попали? :)'}</h2>
        </div>
    );
};

export default PageNotFound;